module.exports = __webpack_public_path__ + "media/assets/events/bg_under-758b6f4841d3826037e8333709df9fc9.png";